import MenuCommittee from './MenuCommittee';
export default MenuCommittee;